import $ from 'jquery';

$(document).on('turbo:load', () => {

  const $topbar = $('#topbar');
  const $navigationMenu = $('#navigation-menu');

  $navigationMenu.on('click', '.dropdown-toggle', function( event ) {
    event.preventDefault();
    event.stopPropagation();

    $navigationMenu.find('.nav-link').removeClass('show');
    $(this).addClass('show');

    $(document).on('click', '.dropdown-menu', ( event ) => event.stopPropagation() );
    $(document).one('click', () => $(this).removeClass('show'));
  });

  $topbar.on('click', '.toggler', () => {
    $topbar.toggleClass('mobile-topbar')
      .parents('body').toggleClass('no-scroll');
  });

  $topbar.on('click', '.mobile-topbar-close-btn', ( event ) => {
    event.preventDefault();

    $topbar.removeClass('mobile-topbar')
      .parents('body').removeClass('no-scroll');
  });
});

$(document).on('turbo:before-cache', () => {
  $('#topbar').removeClass('mobile-topbar')
    .parents('body').removeClass('no-scroll');
});
